import { render, staticRenderFns } from "./PostSettings.vue?vue&type=template&id=4b2ed676"
import script from "./PostSettings.vue?vue&type=script&lang=js"
export * from "./PostSettings.vue?vue&type=script&lang=js"
import style0 from "./PostSettings.vue?vue&type=style&index=0&id=4b2ed676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports